import s from "./getOutletNextReadyToOrderTime.mjs";
import u from "./getOutletPickerTimesForDay.mjs";
import "@ancon/wildcat-types";
import "moment";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../time/getNextTenthMinute.mjs";
import "./getSettingsForOrderFormat.mjs";
import "./isOutletAcceptingPreOrders.mjs";
import "./getOutletTagInformation.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "./constants.mjs";
import "./getOutletCurrentActiveOperatingHour.mjs";
import "./getTimezoneAdjustedServiceInterval.mjs";
import "../time/getTimeSpanParts.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
import "./searchNextOpeningMoment.mjs";
import "./getServiceIntervalsForOrderFormat.mjs";
import "./getOutletNextServiceTimeOffset.mjs";
import "../date/isDSTShiftPresentInRange.mjs";
import "./getPickerIntervalsForDay.mjs";
import "../shared/constants.mjs";
import "./getServiceIntervalStart.mjs";
import "./types.mjs";
import "./generatePickerTimesForDay.mjs";
import "./getServiceIntervalEnd.mjs";
import "./hoursAndMinutesToMinutes.mjs";
function H(r, o, e) {
  const m = s(r, o), i = [], p = m.clone();
  for (let t = 0; t < 7; t += 1)
    i.push(p.clone()), p.add(1, "day");
  return i.reduce((t, c) => {
    const n = u(
      r,
      o,
      c,
      e
    );
    return t.push(n), t;
  }, []).filter((t) => t.length > 0);
}
export {
  H as default
};
